import e from"styled-components";import{theme as i}from"../../../theme.js";const p=e.div`
  padding: ${i.spacing*4}px;
  border-radius: ${i.radius}px;
  box-shadow: ${i.boxShadow};
  .mobile {
    display: none;
  }
  .desktop {
    display: flex;
    justify-content: space-between;
    gap: ${i.spacing*2}px;
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    .mobile {
      display: block;
      .wrapper {
        display: flex;
        justify-content: space-between;
        gap: ${i.spacing*2}px;
      }
    }
    .desktop {
      display: none;
    }
  }
`,a=e.div`
  > img {
    width: 140px;
    height: 140px;
    aspect-ratio: 1/1;
    object-fit: cover;
    border-radius: ${i.radius}px;
  }
  @media screen and (max-width: ${i.breakpoints.md}) {
    > img {
      width: 90px;
      height: 90px;
    }
  }
`,n=e.h3`
  font-size: 20px;
  line-height: 30px;
  margin: 0 0 ${i.spacing}px;
  color: ${i.colors.gray[900]};
  @media screen and (max-width: ${i.breakpoints.md}) {
    font-size: 18px;
  }
`,o=e.div`
  display: flex;
  gap: ${i.spacing*2}px;
  flex-wrap: wrap;
  margin-top: ${i.spacing*2}px;
`,t=e.p`
  color: ${i.colors.gray[500]};
  font-size: 12px;
  line-height: 14px;
  margin: 0 0 ${i.spacing}px;
`;export{p as Container,a as PictureContainer,o as TagsContainer,t as Text,n as Title};
